var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_1" },
    [
      _c("h4", [_vm._v("近期工单动态")]),
      _vm._v(" "),
      _vm._l(_vm.ticketEventList, function(each) {
        return _c(
          "div",
          { key: each.id, staticClass: "_2" },
          [
            _c("span", { staticClass: "_gray" }, [
              _vm._v(_vm._s(each.createdAt))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "_gray" }, [_vm._v("用户")]),
            _vm._v(" "),
            _c("TicketUser", { attrs: { userId: each.dealUserId } }),
            _vm._v(" "),
            _c("TicketOrigin", {
              model: {
                value: each.originId,
                callback: function($$v) {
                  _vm.$set(each, "originId", $$v)
                },
                expression: "each.originId"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "_gray" }, [_vm._v("在工单")]),
            _vm._v(" "),
            _c("TicketTitle", {
              attrs: { ticketTitle: each.ticketTitle, ticketNo: each.orderId }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(each.operateContent))]),
            _vm._v(" "),
            each.orderRemark
              ? _c("span", { staticClass: "ticket-remark-content-summary" }, [
                  _vm._v(_vm._s(each.orderRemark.contentSummary))
                ])
              : _vm._e(),
            _vm._v(" "),
            each.assignUserId
              ? _c(
                  "span",
                  [
                    _vm._v("\n      给\n      "),
                    _c("TicketUser", { attrs: { userId: each.assignUserId } })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            "创建" === each.operateContent
              ? _c("span", { staticClass: "ticket-remark-content-summary" }, [
                  _vm._v(_vm._s(each.ticketContentSummary || "没有描述"))
                ])
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("el-pagination", {
        staticStyle: { "padding-top": "20px" },
        attrs: {
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
          "pager-count": 9,
          "current-page": _vm.page.pageNumber,
          "page-sizes": [10, 25, 50, 100],
          "page-size": _vm.page.pageSize,
          total: _vm.page.recordCount || 0
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.listTicketEvent
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67815d80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67815d80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/RecentTicketEvent.vue
// module id = 1018
// module chunks = 75